const filterViews = {
  receipts: {
    filtrosFijos: [],
    filtrosHabilitados: [
      {
        nombre: 'Folio comprobante',
        campo: 'folio',
        tipo: 'texto'
      },
      {
        nombre: 'Estado',
        campo: 'estado',
        tipo: 'multi',
        opciones: {
          1: 'Emitido',
          2: 'Facturado',
          3: 'ReAdjudicado',
          4: 'Anulado'
        }
      },
      {
        nombre: 'Folio del Lote',
        campo: 'lote.folio',
        tipo: 'texto'
      },
      {
        nombre: 'Rut Adjudicatario',
        campo: 'adjudicatarios.rut',
        tipo: 'texto'
      },
      {
        nombre: 'Razón Social Adjudicatario',
        campo: 'adjudicatarios.nombre',
        tipo: 'texto'
      },
      {
        nombre: 'Fecha de emisión',
        campo: 'fechaEmision',
        tipo: 'fecha',
        valor: ''
      },
      {
        nombre: 'Empresa subasta',
        campo: 'subasta.gestoraId',
        tipo: 'gestoraIds'
      },
      {
        nombre: 'Garantía',
        campo: 'garantiaMonto',
        tipo: 'numero'
      },
      {
        nombre: 'Total adjudicación',
        campo: 'montoTotal',
        tipo: 'numero'
      },
      {
        nombre: 'Fecha máxima de pago',
        campo: 'fechaMaximaPago',
        tipo: 'fecha',
        valor: ''
      },
    ]
  },
  auctions: {
    filtrosFijos: [],
    filtrosHabilitados: [
      {
        nombre: 'Num. Subasta',
        campo: 'folio',
        tipo: 'numero'
      },
      {
        nombre: 'Aduana Coordinadora',
        campo: 'gestoraId',
        tipo: 'gestoraIds'
      },
      {
        nombre: 'Estado',
        campo: 'estado',
        tipo: 'multi',
        opciones: {
          1: 'Creada',
          2: 'En preparación',
          3: 'Planificada',
          4: 'Publicada',
          5: 'Cancelada',
          6: 'Finalizada'
        }
      },
      {
        nombre: 'Fecha de Subasta',
        campo: 'fechaSubasta',
        tipo: 'fecha',
        valor: ''
      }
    ]
  },
  'auctions-history': {
    filtrosFijos: [],
    filtrosHabilitados: [
      {
        nombre: 'Folio de Lote',
        campo: 'lote.folio',
        tipo: 'texto'
      },
      {
        nombre: 'Número Interno',
        campo: 'lote.numeroInterno',
        tipo: 'texto'
      },
      {
        nombre: 'Estado',
        campo: 'lote.estado',
        tipo: 'multi',
        opciones: {
          1: 'Creado',
          2: 'Borrador',
          3: 'En revisión',
          4: 'Rechazado',
          5: 'Anulado',
          6: 'Aprobado',
          7: 'Disponible',
          8: 'Catalogado',
          10: 'Publicado',
          11: 'Adjudicado',
          12: 'Devuelto',
          13: 'Facturado',
          14: 'Rescatado',
          15: 'Donado',
          16: 'Destruído'
        }
      },
      {
        nombre: 'Aduana Loteadora',
        campo: 'lote.loteadoraId',
        tipo: 'loteadoraIds'
      },
      {
        nombre: 'Requiere visto bueno',
        campo: 'lote.requiereVb',
        tipo: 'multi',
        opciones: {
          0: 'No',
          1: 'Si'
        }
      },
      {
        nombre: 'Cantidad de devoluciones',
        campo: 'lote.devolucionesCantidad',
        tipo: 'numero'
      },
      {
        nombre: 'Calidad Jurídica',
        campo: 'lote.calidadJuridicaId',
        tipo: 'calidadJuridicaIds'
      },
      {
        nombre: 'Subasta asociada',
        campo: 'subasta.folio',
        tipo: 'numero'
      },
      {
        nombre: 'Si es ex Lote',
        campo: 'lote.esExLote',
        tipo: 'multi',
        opciones: {
          1: 'Si',
          2: 'No'
        }
      },
      {
        nombre: 'Fecha de Loteo',
        campo: 'lote.fechaLoteo',
        tipo: 'fecha',
        valor: ''
      },
      {
        nombre: 'Monto Mínimo',
        campo: 'lote.montoMinimo',
        tipo: 'numero'
      },
      {
        nombre: 'Usuario creador',
        campo: 'lote.usuarioId',
        tipo: 'usuarioIds'
      }
    ]
  },
  batchs: {
    filtrosFijos: [],
    filtrosHabilitados: [
      {
        nombre: 'Folio de Lote',
        campo: 'folio',
        tipo: 'texto'
      },
      {
        nombre: 'Número Interno',
        campo: 'numeroInterno',
        tipo: 'texto'
      },
      {
        nombre: 'Estado',
        campo: 'estado',
        tipo: 'multi',
        opciones: {
          1: 'Creado',
          2: 'Borrador',
          3: 'En revisión',
          4: 'Rechazado',
          5: 'Anulado',
          6: 'Aprobado',
          7: 'Disponible',
          8: 'Catalogado',
          10: 'Publicado',
          11: 'Adjudicado',
          12: 'Devuelto',
          13: 'Facturado',
          14: 'Rescatado',
          15: 'Donado',
          16: 'Destruído'
        }
      },
      {
        nombre: 'Aduana Loteadora',
        campo: 'loteadoraId',
        tipo: 'loteadoraIds'
      },
      {
        nombre: 'Requiere visto bueno',
        campo: 'requiereVb',
        tipo: 'multi',
        opciones: {
          0: 'No',
          1: 'Si'
        }
      },
      {
        nombre: 'Cantidad de devoluciones',
        campo: 'devolucionesCantidad',
        tipo: 'numero'
      },
      {
        nombre: 'Calidad Jurídica',
        campo: 'calidadJuridicaId',
        tipo: 'calidadJuridicaIds'
      },
      {
        nombre: 'Subasta asociada',
        campo: 'subasta.folio',
        tipo: 'numero'
      },
      {
        nombre: 'Si es ex Lote',
        campo: 'esExLote',
        tipo: 'multi',
        opciones: {
          1: 'Si',
          2: 'No'
        }
      },
      {
        nombre: 'Fecha de Loteo',
        campo: 'fechaLoteo',
        tipo: 'fecha',
        valor: ''
      },
      {
        nombre: 'Monto Mínimo',
        campo: 'montoMinimo',
        tipo: 'numero'
      },
      {
        nombre: 'Usuario creador',
        campo: 'usuarioId',
        tipo: 'usuarioIds'
      }
    ]
  },
  'batchs-review': {
    filtrosFijos: [
      {
        nombre: 'Estado',
        campo: 'estado',
        tipo: 'multi',
        opciones: {
          3: 'En revisión',
        }
      }
    ],
    filtrosHabilitados: [
      {
        nombre: 'Folio de Lote',
        campo: 'folio',
        tipo: 'texto'
      },
      {
        nombre: 'Aduana Loteadora',
        campo: 'loteadoraId',
        tipo: 'loteadoraIds'
      },
      {
        nombre: 'Requiere visto bueno',
        campo: 'requiereVb',
        tipo: 'multi',
        opciones: {
          0: 'No',
          1: 'Si'
        }
      },
      {
        nombre: 'Calidad Jurídica',
        campo: 'calidadJuridicaId',
        tipo: 'calidadJuridicaIds'
      },
      {
        nombre: 'Si es ex Lote',
        campo: 'esExLote',
        tipo: 'multi',
        opciones: {
          0: 'No',
          1: 'Si'
        }
      },
      {
        nombre: 'Fecha Loteo',
        campo: 'fechaLoteo',
        tipo: 'fecha',
        valor: ''
      },
      {
        nombre: 'Monto Mínimo',
        campo: 'montoMinimo',
        tipo: 'numero'
      },
      {
        nombre: 'Usuario creador',
        campo: 'usuarioId',
        tipo: 'usuarioIds'
      }
    ]
  },
  'manage-entities': {
    filtrosFijos: [],
    filtrosHabilitados: [
      {
        nombre: 'Código Entidad',
        campo: 'valor',
        tipo: 'texto'
      },
      {
        nombre: 'Nombre Entidad',
        campo: 'descripcion',
        tipo: 'texto'
      },
    ]
  },
  'manage-products': {
    filtrosFijos: [],
    filtrosHabilitados: [
      {
        nombre: 'Código Producto',
        campo: 'valor',
        tipo: 'texto'
      },
      {
        nombre: 'Nombre Producto',
        campo: 'descripcion',
        tipo: 'texto'
      },
    ]
  },
  'manage-ware-houses': {
    filtrosFijos: [],
    filtrosHabilitados: [
      {
        nombre: 'Código Almacén',
        campo: 'valor',
        tipo: 'texto'
      },
      {
        nombre: 'Nombre Almacén',
        campo: 'descripcion',
        tipo: 'texto'
      },
    ]
  },
  'successful-bidders': {
    filtrosFijos: [],
    filtrosHabilitados: [
      {
        nombre: 'Rut',
        campo: 'rut',
        tipo: 'texto'
      },
      {
        nombre: 'Nombre',
        campo: 'nombre',
        tipo: 'texto'
      },
      {
        nombre: 'Correo',
        campo: 'correo',
        tipo: 'texto',
        buscador: '$'
      },
      {
        nombre: 'Giro',
        campo: 'giro',
        tipo: 'texto'
      },
      {
        nombre: 'Dirección',
        campo: 'direccion',
        tipo: 'texto'
      },
      {
        nombre: 'Comuna',
        campo: 'comuna',
        tipo: 'texto'
      },
      {
        nombre: 'Ciudad',
        campo: 'ciudad',
        tipo: 'texto'
      },
      {
        nombre: 'Contacto',
        campo: 'telefono',
        tipo: 'texto',
        buscador: '$'
      }
    ]
  }
};

export default {
  data() {
    return filterViews;
  },
  methods: {
    getFilterView(view) {
      return filterViews[view];
    }
  }
};
